import colors from 'styles/theme/colors';

export default function StarIcon({
  width = 12,
  height = 12,
  color = colors.blue100,
  ...props
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={width} height={height} viewBox='0 0 12 12' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <g clipPath='url(#clip0_3105_120500)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M0 6C0 2.688 2.682 0 5.994 0C9.312 0 12 2.688 12 6C12 9.312 9.312 12 5.994 12C2.682 12 0 9.312 0 6ZM6.00065 8.07209L8.53865 9.60209L7.86665 6.71009L10.1046 4.77209L7.15265 4.52009L6.00065 1.80209L4.84865 4.52609L1.89665 4.77809L4.13465 6.71609L3.46265 9.60209L6.00065 8.07209Z'
          fill={color}
        />
      </g>
      <defs>
        <clipPath id='clip0_3105_120500'>
          <rect width='12' height='12' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
}
